interface FabProps {
  strings: ReturnType<typeof import("../i18n").t>;
  onClick: () => void;
}

export function renderFab(root: HTMLElement, props: FabProps): void {
  const btn = document.createElement("button");
  btn.className = "dp-fab";
  btn.textContent = props.strings.fab;
  btn.addEventListener("click", props.onClick);
  root.appendChild(btn);
}
